import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "../Cards/Card";
import ComboHeader from "../ComboHeader/ComboHeader";
import NativeObject from "../NativeObject/NativeObject";
import MediaMensal from "../../assets/icons/Simulador/media-mensal.svg";
import Conquistar from "../../assets/icons/Simulador/conquistar.svg";
import Alavancar from "../../assets/icons/Simulador/alavancar.svg";
import Trabalhar from "../../assets/icons/Simulador/trabalhar.svg";
import Ganho from "../../assets/icons/Simulador/ganho.svg";
import TooltipInfo from "../TooltipInfo/TooltipInfo";

function getIcon(icon) {
  switch (icon) {
    case "media-mensal":
      return MediaMensal;
      break;
    case "Conquistar":
      return Conquistar;
      break;
    case "Alavancar":
      return Alavancar;
      break;
    case "Trabalhar":
      return Trabalhar;
      break;
    case "Ganho":
      return Ganho;
      break;

    default:
      return "";
      break;
  }
}

function KpiCardSimulador({
  app,
  KPITitle,
  iconId,
  percentageId,
  greyValueId,
  valueId,
  customStyle,
  isMobile,
  selectedCheck,
  tooltip
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (selectedCheck) {
      console.log("selected", selectedCheck);
    }
  }, [selectedCheck]);

  useEffect(() => {
    if (KPITitle) {
      setLoading(false);
    }
  }, [KPITitle]);
  return (
    <Card
      style={{
        width: "100%",
        padding: "10px",
        justifyContent: "center",
        ...customStyle,
      }}
    >
      {/* TITULO */}
      <ComboHeader
        reference={{
          title: {
            id: KPITitle.id,
            hard: KPITitle.hardTitle,
          },
        }}
        tooltip={tooltip}
        classStyle="combo-header-kpi"
      />

      <div
        style={{
          height: "100%",
          width: isMobile ? null : "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {/*CONTAINER VALUES*/}
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              className={
                greyValueId
                  ? "containerKpiValueBold"
                  : "containerKpiValueBoldUnique"
              }
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "end",
              }}
            >
              <img
                src={getIcon(iconId)}
                alt=""
                style={{ width: "48px", height: "48px", marginRight: "8px" }}
              />
              {/* VALOR PRINCIPAL */}
              <NativeObject
                className="kpiValueBold"
                app={app}
                key={valueId}
                reference={{ id: valueId }}
              />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

KpiCardSimulador.defaultProps = {
  app: null,
  KPITitle: {},
  iconId: null,
  percentageId: null,
  greyValueId: null,
  valueId: null,
  selectedCheck: "",
};

KpiCardSimulador.propTypes = {
  app: PropTypes.object,
  KPITitle: PropTypes.object,
  iconId: PropTypes.string,
  percentageId: PropTypes.string,
  greyValueId: PropTypes.string,
  valueId: PropTypes.string,
  selectedCheck: PropTypes.string,
};

export default KpiCardSimulador;
